import React, {Component} from "react";
import {Layout, message, Select, List, Input, Button, Pagination, Checkbox} from "antd";

import Header from "../../components/header";
import LeftQue from "../../components/leftQue";

import './question.less'
import {
    reqCategory,
    reqDelReply,
    reqDelTopic,
    reqMyQuestion,
    reqReply,
    reqReplyList,
    reqReplyTwo
} from "../../api";
import moment from "moment";
import Modal from "antd/es/modal";
import memoryUtils from "../../utils/memoryUtils";

const {Content} = Layout;
const {Option} = Select;

/**
 * 问题讨论路由组件
 */
export default class Question extends Component {

    state = {
        list: [],
        questionList: [],
        total:0,
        page:1,
        size:10,
        visible:false,
        ModalText:'',
        topicId:0,
        type:'',
        messageId:0,
        selectValue:"",
        text:'',
        itemId:"",
        index:0,
        deleteVisible:false,
        deleteName:"",
        record:{},
        inputVal:'',
        deleteType:'',
        deleteId:"",
    };

    selectChange = e =>{
        this.setState({
            selectValue:e
        })
    };

    getMyQuestionList = async (data) => {
        const result = await reqMyQuestion(data);
        let question = result.data.rows;
        for (let i = 0; question&&i < question.length; i++) {
            question[i]["reply"] = [];
            question[i]["isReply"] = false;
        }
        if(this.state.itemId!==""){
            this.listReply(this.state.itemId,this.state.index)
        }
        this.setState({
            questionList: question,
            total:result.data.total,
            page:result.data.page,
            size:result.data.size
        });
        this.handleCancel();
    };

    itemRender =(current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total)=>{
        return '共'+total+'条记录/每页'+this.state.size+'条';
    };

    replyMessage = (item,index,e) => {
        e.stopPropagation();
        this.setState({
            visible:true,
            ModalText:"回复 "+item.name,
            topicId:item.topicId,
            type:'first',
            itemId:item.topicId,
            index:index
        })
    };

    handleOk = async(e) => {
        e.persist();
        const reply = document.getElementById("reply").value;
        if(reply!==""){
            let data = new FormData();
            data.append("message",reply);
            let result ;
            if(this.state.type==='first'){
                result = await reqReply(this.state.topicId,data);
            }else {
                result = await reqReplyTwo(this.state.topicId,this.state.messageId,data);
            }
            if(result.code==='000000'){
                this.getMyQuestionList({page:1, size:10});
                this.handleCancel();
                this.setState({
                    inputVal:''
                })
            }
        }else {
            message.error("请输入回复内容");
        }
    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible:false,
        });
    };

    listReply = async(itemId,index)=> {
        let questions = this.state.questionList;
        if(questions[index]["isReply"] === false) {
            const result = await reqReplyList(itemId, {page: 1, size: 100});
            questions[index]["reply"] = result.data.rows;
            questions[index]["isReply"] = true;
        }else{
            questions[index]["reply"] =[];
            questions[index]["isReply"] = false;
        }
        this.setState({
            questionList: questions,
            itemId: itemId,
            index: index
        });
    };

    replyTwo =(re)=>{
        this.setState({
            visible:true,
            ModalText:"回复 "+re.name,
            topicId:re.topicId,
            type:'two',
            messageId:re.messageId
        })
    };

    deleteModal=(re,type)=>{
        if(type ==='批量删除'){
            if(this.state.deleteId) {
                this.setState({
                    deleteVisible:true,
                    deleteType:'批量删除'
                });
            }else {
                message.info("没有选中行");
            }
        }else {
            this.setState({
                record:re,
                deleteVisible:true,
                deleteName:re.message,
                deleteType:'删除回复'
            })
        }
    };

    deleteMessage = async (re) => {
        if(this.state.deleteType==="批量删除"){
            const result = await reqDelTopic(this.state.deleteId);
            if (result.code === '000000') {
                message.success("删除成功");
                this.getMyQuestionList({page: 1, size: 10});
            }
        }else {
            let data = new FormData();
            data.append("message", re.message);
            const result = await reqDelReply(re.topicId, re.messageId, re.message);
            if (result.code === '000000') {
                message.success("删除成功");
                this.getMyQuestionList({page: 1, size: 10});
            }
        }
    };

    pageClick = async page => {
        let keyword = document.getElementsByClassName("que_input")[0].value;
        let data = {
            page:page,
            size:10
        };
        if (keyword&&keyword !== '') {
            data["keyword"] = keyword;
        }
        if (this.state.selectValue !== '') {
            data["cid"] = this.state.selectValue
        }
        this.setState({
            itemId:""
        });
        this.getMyQuestionList(data);
    };

    bindInput= async e =>{
        this.setState({
            inputVal:e.target.value
        })
    };

    searchList = async () => {
        let keyword = document.getElementsByClassName("que_input")[0].value;
        let data = {
            page:1,
            size:10
        };
        if (keyword&&keyword !== '') {
            data["keyword"] = keyword;
        }
        if (this.state.selectValue !== '') {
            data["cid"] = this.state.selectValue
        }
        this.getMyQuestionList(data);
    };

    clearAll=()=>{
        sessionStorage.clear();
        window.location.reload();
    };

    onChange = e => {
        let deleteName = "";
        let deleteId = "";
        for (let i = 0; i < e.length; i++) {
            deleteId += e[i].split("|")[0];
            deleteName += e[i].split("|")[1];
            if(i< e.length-1) {
                deleteId += ",";
                deleteName += ",";
            }
        }
        this.setState({
            deleteName:deleteName,
            deleteId:deleteId
        });
    };

    checkClick = e => {
        e.stopPropagation();
    };

    maxPic = (pics)=> {
        Modal.info({
            title: '',
            width:'40%',
            okText:'关闭',
            icon:'none',
            className:'pic',
            content: (
                <div>
                    <img style={{width:"100%",height:"auto"}} src={global.constant.uploadImage + pics} />
                </div>
            ),
            onOk() {},
        });
    };

    componentDidMount = async () => {
        const result = await reqCategory("CASE");
        this.setState({
            list: result.data.rows
        });
        let data = {
            page:1,
            size:10
        };
        this.getMyQuestionList(data);
        document.getElementsByClassName("ant-menu-item")[2].click();
    };

    render() {

        const self = this;
        const {list, questionList,total,inputVal,page,size,visible,ModalText,deleteVisible,record} = this.state;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftQue>LeftQue</LeftQue>
                    <Content>
                        <div className='que_filter'>
                            <Button className='batch_delete'
                                    onClick={this.deleteModal.bind(this, "", '批量删除')}>批量删除</Button>
                            <div className="search_bar">
                                <Button className='filter_btn gray' onClick={this.clearAll.bind(this)}>重置</Button>
                                <Button className='filter_btn blue' onClick={this.searchList.bind(this)}>检索</Button>
                                <div className='search_box' style={{width:200}}>
                                    <Input placeholder={"请输入关键词搜索"} className='que_input'/>
                                </div>
                                <div className='search_box'>
                                    <label>问题分类</label>
                                    <Select id='search_select'
                                            showSearch
                                            style={{width: 200}}
                                            defaultValue={0}
                                            onChange={this.selectChange.bind(this)}
                                            optionFilterProp="children">
                                        <Option key={'all'} value={0}>全部</Option>
                                        {
                                            list&&list.map((item, index) => (
                                                <Option key={index} value={item.id}>{item.name}</Option>
                                            ))
                                        }
                                    </Select>
                                </div>
                            </div>
                        </div>
                        <div className='que_box'>
                            <Checkbox.Group onChange={this.onChange} style={{width:"100%"}}>
                            <List  itemLayout="vertical" size="large"
                                   dataSource={questionList} renderItem={(item,index) => (
                                <List.Item id={item.topicId} key={item.id} onClick={this.listReply.bind(this,item.topicId,index)} className='reply_list'>
                                    <div className={"checkbox"}><Checkbox value={item.topicId+"|"+item.title} onClick={self.checkClick.bind(self)}/></div>
                                    <div className='list_user'>
                                        <img className='list_img' src={item.userAvatar?global.constant.uploadImage + item.userAvatar:require("../../assets/images/head.png")}/>
                                        <div className='list_name'>{item.name}</div>
                                    </div>
                                    <div className='list_content'>
                                        <div className='list_title'>{item.title}</div>
                                        <div className='list_message'>{item.message}</div>
                                    </div>
                                    <div className='list_image'>
                                        {
                                            item.imgs && item.imgs.map((id, key) => (
                                                <img onClick={self.maxPic.bind(self,id)} style={{cursor:'pointer'}} key={key} src={global.constant.uploadImage+id}/>
                                            ))
                                        }
                                    </div>
                                    <div className='list_reply'>
                                        <Button onClick={this.replyMessage.bind(this,item,index)}>回复</Button>
                                        <div>{moment(item.createTime).format("YYYY-MM-DD")}</div>
                                    </div>
                                    {
                                        item.reply && item.reply.map((re, k) => (
                                            <div className='topic_reply' key={k}>
                                                <div className='bottom_border'>
                                                    <div className='reply_user'>
                                                        <div className='reply_left'>
                                                            <img className='reply_img' src={re.userAvatar?global.constant.uploadImage + re.userAvatar:require("../../assets/images/head.png")}/>
                                                            {
                                                                (re.hasOwnProperty("targetName"))?<span className='reply_name'>{re.name} <span style={{color:'#989898'}}>回复</span> {re.targetName}</span>:<span className='reply_name'>{re.name}</span>
                                                            }
                                                        </div>
                                                        <div className='reply_content'>{re.message}</div>
                                                    </div>
                                                    <div className='reply_btn'>
                                                        {
                                                            (re.hasOwnProperty("targetName"))?'':<a className='btn_re blue' onClick={()=>self.replyTwo(re)}>回复</a>
                                                        }
                                                        {
                                                            (re.userId===memoryUtils.user.userId)?<a className='btn_re black' onClick={()=>self.deleteModal(re,'删除')}>删除</a>:''
                                                        }
                                                        <span>{moment(re.createTime).format("MM-DD")}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </List.Item>)}
                            />
                            </Checkbox.Group>
                            <Pagination total={total} current={page} pageSize={size} onChange={this.pageClick} itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal
                            title={ModalText}
                            visible={visible}
                            okText={'确定'}
                            cancelText={'取消'}
                            onOk={this.handleOk}
                            onCancel={this.handleCancel.bind(this)}>
                            <textarea className={"textarea"} rows={8} id='reply' value={inputVal} onChange={this.bindInput}/>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteMessage.bind(this,record)}
                            onCancel={this.handleCancel}>
                            <div>确定删除？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}